import React, { Component } from 'react';
import { Blueprint, BlueprintStep, BlueprintValue } from '@ekkogmbh/apisdk';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { ArrowDownward, ArrowForward, StickyNote2Rounded } from '@mui/icons-material';
import { StyledFormHeader } from 'src/Common/Components/Forms/StyledFormHeader';

interface BlueprintStepsDialogProps {
  blueprint: Blueprint;
  onClose: () => void;
}

export class BlueprintStepsDialog extends Component<BlueprintStepsDialogProps> {
  private renderValues = (values: BlueprintValue[]): React.JSX.Element => (
    <List dense>
      {values.map((value: BlueprintValue, index: number) => (
        <ListItem key={index}>
          <ListItemText>
            <Stack direction={'row'} spacing={4} alignItems={'stretch'} justifyContent={'space-between'}>
              <Typography>{value.amount}</Typography>
              <Typography fontWeight={700}>{value.value}</Typography>
              {value.metadata && Object.keys(value.metadata).length > 0 && (
                <Tooltip
                  title={
                    <List dense>
                      {Object.keys(value.metadata).map((meta, idx) => (
                        <ListItem key={idx}>
                          <ListItemText primary={meta} secondary={value.metadata![meta]} />
                        </ListItem>
                      ))}
                    </List>
                  }
                >
                  <Icon>
                    <StickyNote2Rounded color={'primary'} />
                  </Icon>
                </Tooltip>
              )}
            </Stack>
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );

  private renderStep = (step: BlueprintStep, index: number): React.JSX.Element => (
    <Paper key={index} elevation={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'center', sm: 'flex-start' }}
        justifyContent={'center'}
      >
        <Stack direction={'column'} spacing={0} alignItems={'stretch'}>
          <StyledFormHeader label={'source'} />
          {this.renderValues(step.source)}
        </Stack>
        <Box display={{ xs: 'none', sm: 'block' }}>
          <ArrowForward color={'primary'} />
        </Box>
        <Box display={{ xs: 'block', sm: 'none' }}>
          <ArrowDownward color={'primary'} />
        </Box>
        <Stack direction={'column'} spacing={0} alignItems={'stretch'}>
          <StyledFormHeader label={'destination'} />
          {this.renderValues(step.destination)}
        </Stack>
      </Stack>
    </Paper>
  );

  public render(): React.JSX.Element {
    const { blueprint, onClose } = this.props;

    return (
      <Dialog fullWidth open onClose={onClose}>
        <DialogTitle>Blueprint Steps - {blueprint.name}</DialogTitle>
        <DialogContent>
          <Stack direction={'column'} spacing={1}>
            {blueprint.steps.map((step, i) => this.renderStep(step, i))}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" variant={'contained'}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
